import { Fragment, memo } from 'react';
import { useTranslation } from 'react-i18next';

import { SVGIconType } from '../../../../constants/svgIcon';
import { SvgIcon } from '../../../Molecules';

import styles from './WebStoreEnterPurchaseClubTemplate.module.css';

type Version = {
  classroomId: string;
  title: string;
  description: string;
  expiredAt: Date | undefined;
};

export type WebStoreEnterPurchaseClubTemplateProps = {
  versions: Version[];
  onClickEnter: (classroomId: string) => void;
};

export const WebStoreEnterPurchaseClubTemplate = memo(
  ({ versions, onClickEnter }: WebStoreEnterPurchaseClubTemplateProps) => {
    const { t, i18n } = useTranslation();

    const options: Intl.DateTimeFormatOptions = {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    };

    const formattedDate = (expiredAt: Date | undefined) => {
      return expiredAt
        ? new Intl.DateTimeFormat(i18n.language, options).format(expiredAt)
        : undefined;
    };

    return (
      <div className={styles.enterPurchaseClub}>
        <div className={styles.title}>{t('Enter Purchased Club')}</div>
        <ul className={styles.versionList}>
          {versions.map((item, index) => (
            <Fragment key={index}>
              <li className={`${styles.versionItem}`}>
                <div className={styles.textItem}>
                  <div className={styles.itemTitle}>{item.title}</div>
                  <div className={styles.itemDescription}>
                    {item.description}
                  </div>
                  <div className={styles.itemExpireDate}>
                    {`${t('Expire on: ')} ${formattedDate(item.expiredAt)}`}
                  </div>
                </div>
                <button
                  className={styles.enterButton}
                  onClick={() => {
                    onClickEnter(item.classroomId);
                  }}
                >
                  {t('Enter Club')}
                  <SvgIcon
                    name={SVGIconType.Arrow}
                    className={styles.rightIcon}
                  />
                </button>
              </li>
              {index < versions.length - 1 && <hr />}
            </Fragment>
          ))}
        </ul>
      </div>
    );
  },
);
